import Ee, { useRef as Ce, useCallback as _e, useEffect as $, useLayoutEffect as Ue, useState as _, useMemo as Z } from "react";
import Fe from "react-dom";
var O = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function De(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var H = {}, B = {}, G = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.isEventSourceSupported = e.isReactNative = e.ReadyState = e.UNPARSABLE_JSON_OBJECT = e.DEFAULT_RECONNECT_INTERVAL_MS = e.DEFAULT_RECONNECT_LIMIT = e.SOCKET_IO_PING_CODE = e.SOCKET_IO_PATH = e.SOCKET_IO_PING_INTERVAL = e.DEFAULT_EVENT_SOURCE_OPTIONS = e.EMPTY_EVENT_HANDLERS = e.DEFAULT_OPTIONS = void 0;
  var r = 1, t = 1e3 * r;
  e.DEFAULT_OPTIONS = {}, e.EMPTY_EVENT_HANDLERS = {}, e.DEFAULT_EVENT_SOURCE_OPTIONS = {
    withCredentials: !1,
    events: e.EMPTY_EVENT_HANDLERS
  }, e.SOCKET_IO_PING_INTERVAL = 25 * t, e.SOCKET_IO_PATH = "/socket.io/?EIO=3&transport=websocket", e.SOCKET_IO_PING_CODE = "2", e.DEFAULT_RECONNECT_LIMIT = 20, e.DEFAULT_RECONNECT_INTERVAL_MS = 5e3, e.UNPARSABLE_JSON_OBJECT = {}, function(o) {
    o[o.UNINSTANTIATED = -1] = "UNINSTANTIATED", o[o.CONNECTING = 0] = "CONNECTING", o[o.OPEN = 1] = "OPEN", o[o.CLOSING = 2] = "CLOSING", o[o.CLOSED = 3] = "CLOSED";
  }(e.ReadyState || (e.ReadyState = {}));
  var n = function() {
    try {
      return "EventSource" in globalThis;
    } catch {
      return !1;
    }
  };
  e.isReactNative = typeof navigator < "u" && navigator.product === "ReactNative", e.isEventSourceSupported = !e.isReactNative && n();
})(G);
var se = {}, ce = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.resetWebSockets = e.sharedWebSockets = void 0, e.sharedWebSockets = {};
  var r = function(t) {
    if (t && e.sharedWebSockets.hasOwnProperty(t))
      delete e.sharedWebSockets[t];
    else
      for (var n in e.sharedWebSockets)
        e.sharedWebSockets.hasOwnProperty(n) && delete e.sharedWebSockets[n];
  };
  e.resetWebSockets = r;
})(ce);
var ie = {}, D = {};
Object.defineProperty(D, "__esModule", { value: !0 });
D.setUpSocketIOPing = D.appendQueryParams = D.parseSocketIOUrl = void 0;
var te = G, $e = function(e) {
  if (e) {
    var r = /^https|wss/.test(e), t = e.replace(/^(https?|wss?)(:\/\/)?/, ""), n = t.replace(/\/$/, ""), o = r ? "wss" : "ws";
    return "".concat(o, "://").concat(n).concat(te.SOCKET_IO_PATH);
  } else if (e === "") {
    var r = /^https/.test(window.location.protocol), o = r ? "wss" : "ws", a = window.location.port ? ":".concat(window.location.port) : "";
    return "".concat(o, "://").concat(window.location.hostname).concat(a).concat(te.SOCKET_IO_PATH);
  }
  return e;
};
D.parseSocketIOUrl = $e;
var je = function(e, r) {
  r === void 0 && (r = {});
  var t = /\?([\w]+=[\w]+)/, n = t.test(e), o = "".concat(Object.entries(r).reduce(function(a, c) {
    var u = c[0], l = c[1];
    return a + "".concat(u, "=").concat(l, "&");
  }, "").slice(0, -1));
  return "".concat(e).concat(n ? "&" : "?").concat(o);
};
D.appendQueryParams = je;
var Je = function(e, r) {
  r === void 0 && (r = te.SOCKET_IO_PING_INTERVAL);
  var t = function() {
    return e(te.SOCKET_IO_PING_CODE);
  };
  return window.setInterval(t, r);
};
D.setUpSocketIOPing = Je;
var V = {}, ue = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.resetSubscribers = e.removeSubscriber = e.addSubscriber = e.hasSubscribers = e.getSubscribers = void 0;
  var r = {}, t = [], n = function(l) {
    return (0, e.hasSubscribers)(l) ? Array.from(r[l]) : t;
  };
  e.getSubscribers = n;
  var o = function(l) {
    var s;
    return ((s = r[l]) === null || s === void 0 ? void 0 : s.size) > 0;
  };
  e.hasSubscribers = o;
  var a = function(l, s) {
    r[l] = r[l] || /* @__PURE__ */ new Set(), r[l].add(s);
  };
  e.addSubscriber = a;
  var c = function(l, s) {
    r[l].delete(s);
  };
  e.removeSubscriber = c;
  var u = function(l) {
    if (l && r.hasOwnProperty(l))
      delete r[l];
    else
      for (var s in r)
        r.hasOwnProperty(s) && delete r[s];
  };
  e.resetSubscribers = u;
})(ue);
Object.defineProperty(V, "__esModule", { value: !0 });
V.resetGlobalState = V.assertIsWebSocket = void 0;
var Ge = ce, xe = ue;
function He(e, r) {
  if (!r && !(e instanceof WebSocket))
    throw new Error("");
}
V.assertIsWebSocket = He;
function Ve(e) {
  (0, xe.resetSubscribers)(e), (0, Ge.resetWebSockets)(e);
}
V.resetGlobalState = Ve;
var re = O && O.__assign || function() {
  return re = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, re.apply(this, arguments);
};
Object.defineProperty(ie, "__esModule", { value: !0 });
ie.attachListeners = void 0;
var Ye = D, F = G, qe = V, Ke = function(e, r, t) {
  e.onmessage = function(n) {
    r.current.onMessage && r.current.onMessage(n), !(typeof r.current.filter == "function" && r.current.filter(n) !== !0) && t(n);
  };
}, Be = function(e, r, t, n) {
  e.onopen = function(o) {
    r.current.onOpen && r.current.onOpen(o), n.current = 0, t(F.ReadyState.OPEN);
  };
}, Qe = function(e, r, t, n, o) {
  if (F.isEventSourceSupported && e instanceof EventSource)
    return function() {
    };
  (0, qe.assertIsWebSocket)(e, r.current.skipAssert);
  var a;
  return e.onclose = function(c) {
    var u, l;
    if (r.current.onClose && r.current.onClose(c), t(F.ReadyState.CLOSED), r.current.shouldReconnect && r.current.shouldReconnect(c)) {
      var s = (u = r.current.reconnectAttempts) !== null && u !== void 0 ? u : F.DEFAULT_RECONNECT_LIMIT;
      o.current < s ? a = window.setTimeout(function() {
        o.current++, n();
      }, (l = r.current.reconnectInterval) !== null && l !== void 0 ? l : F.DEFAULT_RECONNECT_INTERVAL_MS) : (r.current.onReconnectStop && r.current.onReconnectStop(s), console.warn("Max reconnect attempts of ".concat(s, " exceeded")));
    }
  }, function() {
    return a && window.clearTimeout(a);
  };
}, ze = function(e, r, t, n, o) {
  var a;
  return e.onerror = function(c) {
    var u, l;
    r.current.onError && r.current.onError(c), F.isEventSourceSupported && e instanceof EventSource && (r.current.onClose && r.current.onClose(re(re({}, c), { code: 1006, reason: "An error occurred with the EventSource: ".concat(c), wasClean: !1 })), t(F.ReadyState.CLOSED), e.close()), r.current.retryOnError && (o.current < ((u = r.current.reconnectAttempts) !== null && u !== void 0 ? u : F.DEFAULT_RECONNECT_LIMIT) ? a = window.setTimeout(function() {
      o.current++, n();
    }, (l = r.current.reconnectInterval) !== null && l !== void 0 ? l : F.DEFAULT_RECONNECT_INTERVAL_MS) : (r.current.onReconnectStop && r.current.onReconnectStop(r.current.reconnectAttempts), console.warn("Max reconnect attempts of ".concat(r.current.reconnectAttempts, " exceeded"))));
  }, function() {
    return a && window.clearTimeout(a);
  };
}, Xe = function(e, r, t, n, o, a) {
  var c = r.setLastMessage, u = r.setReadyState, l, s, f;
  return t.current.fromSocketIO && (l = (0, Ye.setUpSocketIOPing)(a)), Ke(e, t, c), Be(e, t, u, o), s = Qe(e, t, u, n, o), f = ze(e, t, u, n, o), function() {
    u(F.ReadyState.CLOSING), s(), f(), e.close(), l && clearInterval(l);
  };
};
ie.attachListeners = Xe;
var le = {}, ne = O && O.__assign || function() {
  return ne = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, ne.apply(this, arguments);
};
Object.defineProperty(le, "__esModule", { value: !0 });
le.attachSharedListeners = void 0;
var Ze = ce, Y = G, X = ue, et = D, tt = function(e, r) {
  e.onmessage = function(t) {
    (0, X.getSubscribers)(r).forEach(function(n) {
      n.optionsRef.current.onMessage && n.optionsRef.current.onMessage(t), !(typeof n.optionsRef.current.filter == "function" && n.optionsRef.current.filter(t) !== !0) && n.setLastMessage(t);
    });
  };
}, rt = function(e, r) {
  e.onopen = function(t) {
    (0, X.getSubscribers)(r).forEach(function(n) {
      n.reconnectCount.current = 0, n.optionsRef.current.onOpen && n.optionsRef.current.onOpen(t), n.setReadyState(Y.ReadyState.OPEN);
    });
  };
}, nt = function(e, r) {
  e instanceof WebSocket && (e.onclose = function(t) {
    (0, X.getSubscribers)(r).forEach(function(n) {
      n.optionsRef.current.onClose && n.optionsRef.current.onClose(t), n.setReadyState(Y.ReadyState.CLOSED);
    }), delete Ze.sharedWebSockets[r], (0, X.getSubscribers)(r).forEach(function(n) {
      var o, a;
      if (n.optionsRef.current.shouldReconnect && n.optionsRef.current.shouldReconnect(t)) {
        var c = (o = n.optionsRef.current.reconnectAttempts) !== null && o !== void 0 ? o : Y.DEFAULT_RECONNECT_LIMIT;
        n.reconnectCount.current < c ? setTimeout(function() {
          n.reconnectCount.current++, n.reconnect.current();
        }, (a = n.optionsRef.current.reconnectInterval) !== null && a !== void 0 ? a : Y.DEFAULT_RECONNECT_INTERVAL_MS) : (n.optionsRef.current.onReconnectStop && n.optionsRef.current.onReconnectStop(n.optionsRef.current.reconnectAttempts), console.warn("Max reconnect attempts of ".concat(c, " exceeded")));
      }
    });
  });
}, at = function(e, r) {
  e.onerror = function(t) {
    (0, X.getSubscribers)(r).forEach(function(n) {
      n.optionsRef.current.onError && n.optionsRef.current.onError(t), Y.isEventSourceSupported && e instanceof EventSource && (n.optionsRef.current.onClose && n.optionsRef.current.onClose(ne(ne({}, t), { code: 1006, reason: "An error occurred with the EventSource: ".concat(t), wasClean: !1 })), n.setReadyState(Y.ReadyState.CLOSED));
    }), Y.isEventSourceSupported && e instanceof EventSource && e.close();
  };
}, ot = function(e, r, t, n) {
  var o;
  return t.current.fromSocketIO && (o = (0, et.setUpSocketIOPing)(n)), tt(e, r), nt(e, r), rt(e, r), at(e, r), function() {
    o && clearInterval(o);
  };
};
le.attachSharedListeners = ot;
Object.defineProperty(se, "__esModule", { value: !0 });
se.createOrJoinSocket = void 0;
var x = ce, z = G, st = ie, ct = le, ye = ue, it = function(e, r, t, n, o) {
  return function() {
    if ((0, ye.removeSubscriber)(e, r), !(0, ye.hasSubscribers)(e)) {
      try {
        var a = x.sharedWebSockets[e];
        a instanceof WebSocket && (a.onclose = function(c) {
          t.current.onClose && t.current.onClose(c), n(z.ReadyState.CLOSED);
        }), a.close();
      } catch {
      }
      o && o(), delete x.sharedWebSockets[e];
    }
  };
}, ut = function(e, r, t, n, o, a, c, u) {
  if (!z.isEventSourceSupported && n.current.eventSourceOptions)
    throw z.isReactNative ? new Error("EventSource is not supported in ReactNative") : new Error("EventSource is not supported");
  if (n.current.share) {
    var l = null;
    x.sharedWebSockets[r] === void 0 ? (x.sharedWebSockets[r] = n.current.eventSourceOptions ? new EventSource(r, n.current.eventSourceOptions) : new WebSocket(r, n.current.protocols), e.current = x.sharedWebSockets[r], t(z.ReadyState.CONNECTING), l = (0, ct.attachSharedListeners)(x.sharedWebSockets[r], r, n, u)) : (e.current = x.sharedWebSockets[r], t(x.sharedWebSockets[r].readyState));
    var s = {
      setLastMessage: o,
      setReadyState: t,
      optionsRef: n,
      reconnectCount: c,
      reconnect: a
    };
    return (0, ye.addSubscriber)(r, s), it(r, s, n, t, l);
  } else {
    if (e.current = n.current.eventSourceOptions ? new EventSource(r, n.current.eventSourceOptions) : new WebSocket(r, n.current.protocols), t(z.ReadyState.CONNECTING), !e.current)
      throw new Error("WebSocket failed to be created");
    return (0, st.attachListeners)(e.current, {
      setLastMessage: o,
      setReadyState: t
    }, n, a.current, c, u);
  }
};
se.createOrJoinSocket = ut;
var fe = {}, lt = O && O.__awaiter || function(e, r, t, n) {
  function o(a) {
    return a instanceof t ? a : new t(function(c) {
      c(a);
    });
  }
  return new (t || (t = Promise))(function(a, c) {
    function u(f) {
      try {
        s(n.next(f));
      } catch (v) {
        c(v);
      }
    }
    function l(f) {
      try {
        s(n.throw(f));
      } catch (v) {
        c(v);
      }
    }
    function s(f) {
      f.done ? a(f.value) : o(f.value).then(u, l);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, ft = O && O.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (a[0] & 1)
      throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, o, a, c;
  return c = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (c[Symbol.iterator] = function() {
    return this;
  }), c;
  function u(s) {
    return function(f) {
      return l([s, f]);
    };
  }
  function l(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; t; )
      try {
        if (n = 1, o && (a = s[0] & 2 ? o.return : s[0] ? o.throw || ((a = o.return) && a.call(o), 0) : o.next) && !(a = a.call(o, s[1])).done)
          return a;
        switch (o = 0, a && (s = [s[0] & 2, a.value]), s[0]) {
          case 0:
          case 1:
            a = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, o = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (a = t.trys, !(a = a.length > 0 && a[a.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!a || s[1] > a[0] && s[1] < a[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < a[1]) {
              t.label = a[1], a = s;
              break;
            }
            if (a && t.label < a[2]) {
              t.label = a[2], t.ops.push(s);
              break;
            }
            a[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], o = 0;
      } finally {
        n = a = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
};
Object.defineProperty(fe, "__esModule", { value: !0 });
fe.getUrl = void 0;
var he = D, dt = function(e, r) {
  return lt(void 0, void 0, void 0, function() {
    var t, n, o;
    return ft(this, function(a) {
      switch (a.label) {
        case 0:
          return typeof e != "function" ? [3, 2] : [4, e()];
        case 1:
          return t = a.sent(), [3, 3];
        case 2:
          t = e, a.label = 3;
        case 3:
          return n = r.current.fromSocketIO ? (0, he.parseSocketIOUrl)(t) : t, o = r.current.queryParams ? (0, he.appendQueryParams)(n, r.current.queryParams) : n, [2, o];
      }
    });
  });
};
fe.getUrl = dt;
var Pe = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.websocketWrapper = void 0;
  var r = function(t, n) {
    return new Proxy(t, {
      get: function(o, a) {
        var c = o[a];
        return a === "reconnect" ? n : typeof c == "function" ? (console.error("Calling methods directly on the websocket is not supported at this moment. You must use the methods returned by useWebSocket."), function() {
        }) : c;
      },
      set: function(o, a, c) {
        return /^on/.test(a) ? (console.warn("The websocket's event handlers should be defined through the options object passed into useWebSocket."), !1) : (o[a] = c, !0);
      }
    });
  };
  e.websocketWrapper = r, e.default = e.websocketWrapper;
})(Pe);
var K = O && O.__assign || function() {
  return K = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, K.apply(this, arguments);
}, vt = O && O.__awaiter || function(e, r, t, n) {
  function o(a) {
    return a instanceof t ? a : new t(function(c) {
      c(a);
    });
  }
  return new (t || (t = Promise))(function(a, c) {
    function u(f) {
      try {
        s(n.next(f));
      } catch (v) {
        c(v);
      }
    }
    function l(f) {
      try {
        s(n.throw(f));
      } catch (v) {
        c(v);
      }
    }
    function s(f) {
      f.done ? a(f.value) : o(f.value).then(u, l);
    }
    s((n = n.apply(e, r || [])).next());
  });
}, St = O && O.__generator || function(e, r) {
  var t = { label: 0, sent: function() {
    if (a[0] & 1)
      throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, o, a, c;
  return c = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (c[Symbol.iterator] = function() {
    return this;
  }), c;
  function u(s) {
    return function(f) {
      return l([s, f]);
    };
  }
  function l(s) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; t; )
      try {
        if (n = 1, o && (a = s[0] & 2 ? o.return : s[0] ? o.throw || ((a = o.return) && a.call(o), 0) : o.next) && !(a = a.call(o, s[1])).done)
          return a;
        switch (o = 0, a && (s = [s[0] & 2, a.value]), s[0]) {
          case 0:
          case 1:
            a = s;
            break;
          case 4:
            return t.label++, { value: s[1], done: !1 };
          case 5:
            t.label++, o = s[1], s = [0];
            continue;
          case 7:
            s = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (a = t.trys, !(a = a.length > 0 && a[a.length - 1]) && (s[0] === 6 || s[0] === 2)) {
              t = 0;
              continue;
            }
            if (s[0] === 3 && (!a || s[1] > a[0] && s[1] < a[3])) {
              t.label = s[1];
              break;
            }
            if (s[0] === 6 && t.label < a[1]) {
              t.label = a[1], a = s;
              break;
            }
            if (a && t.label < a[2]) {
              t.label = a[2], t.ops.push(s);
              break;
            }
            a[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        s = r.call(e, t);
      } catch (f) {
        s = [6, f], o = 0;
      } finally {
        n = a = 0;
      }
    if (s[0] & 5)
      throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, gt = O && O.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(B, "__esModule", { value: !0 });
B.useWebSocket = void 0;
var R = Ee, Oe = Fe, J = G, _t = se, yt = fe, Et = gt(Pe), pe = V, mt = function(e, r, t) {
  r === void 0 && (r = J.DEFAULT_OPTIONS), t === void 0 && (t = !0);
  var n = (0, R.useState)(null), o = n[0], a = n[1], c = (0, R.useState)({}), u = c[0], l = c[1], s = (0, R.useMemo)(function() {
    if (o)
      try {
        return JSON.parse(o.data);
      } catch {
        return J.UNPARSABLE_JSON_OBJECT;
      }
    return null;
  }, [o]), f = (0, R.useRef)(null), v = (0, R.useRef)(null), b = (0, R.useRef)(function() {
  }), M = (0, R.useRef)(0), C = (0, R.useRef)([]), P = (0, R.useRef)(null), S = (0, R.useRef)(r);
  S.current = r;
  var E = f.current && u[f.current] !== void 0 ? u[f.current] : e !== null && t === !0 ? J.ReadyState.CONNECTING : J.ReadyState.UNINSTANTIATED, I = r.queryParams ? JSON.stringify(r.queryParams) : null, g = (0, R.useCallback)(function(y, p) {
    var k;
    if (p === void 0 && (p = !0), J.isEventSourceSupported && v.current instanceof EventSource) {
      console.warn("Unable to send a message from an eventSource");
      return;
    }
    ((k = v.current) === null || k === void 0 ? void 0 : k.readyState) === J.ReadyState.OPEN ? ((0, pe.assertIsWebSocket)(v.current, S.current.skipAssert), v.current.send(y)) : p && C.current.push(y);
  }, []), h = (0, R.useCallback)(function(y, p) {
    p === void 0 && (p = !0), g(JSON.stringify(y), p);
  }, [g]), A = (0, R.useCallback)(function() {
    return S.current.share !== !0 || J.isEventSourceSupported && v.current instanceof EventSource ? v.current : (P.current === null && v.current && ((0, pe.assertIsWebSocket)(v.current, S.current.skipAssert), P.current = (0, Et.default)(v.current, b)), P.current);
  }, []);
  return (0, R.useEffect)(function() {
    if (e !== null && t === !0) {
      var y, p = !1, k = !0, U = function() {
        return vt(void 0, void 0, void 0, function() {
          var W, d, T;
          return St(this, function(L) {
            switch (L.label) {
              case 0:
                return W = f, [4, (0, yt.getUrl)(e, S)];
              case 1:
                return W.current = L.sent(), d = function(w) {
                  p || (0, Oe.flushSync)(function() {
                    return a(w);
                  });
                }, T = function(w) {
                  p || (0, Oe.flushSync)(function() {
                    return l(function(i) {
                      var j;
                      return K(K({}, i), f.current && (j = {}, j[f.current] = w, j));
                    });
                  });
                }, k && (y = (0, _t.createOrJoinSocket)(v, f.current, T, S, d, b, M, g)), [2];
            }
          });
        });
      };
      return b.current = function() {
        p || (P.current && (P.current = null), y == null || y(), U());
      }, U(), function() {
        p = !0, k = !1, P.current && (P.current = null), y == null || y(), a(null);
      };
    } else
      (e === null || t === !1) && (M.current = 0, l(function(W) {
        var d;
        return K(K({}, W), f.current && (d = {}, d[f.current] = J.ReadyState.CLOSED, d));
      }));
  }, [e, t, I, g]), (0, R.useEffect)(function() {
    E === J.ReadyState.OPEN && C.current.splice(0).forEach(function(y) {
      g(y);
    });
  }, [E]), {
    sendMessage: g,
    sendJsonMessage: h,
    lastMessage: o,
    lastJsonMessage: s,
    readyState: E,
    getWebSocket: A
  };
};
B.useWebSocket = mt;
var de = {}, ae = O && O.__assign || function() {
  return ae = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, ae.apply(this, arguments);
};
Object.defineProperty(de, "__esModule", { value: !0 });
de.useSocketIO = void 0;
var we = Ee, bt = B, ht = G, ge = {
  type: "empty",
  payload: null
}, Ot = function(e) {
  if (!e || !e.data)
    return ge;
  var r = e.data.match(/\[.*]/);
  if (!r)
    return ge;
  var t = JSON.parse(r);
  return !Array.isArray(t) || !t[1] ? ge : {
    type: t[0],
    payload: t[1]
  };
}, pt = function(e, r, t) {
  r === void 0 && (r = ht.DEFAULT_OPTIONS), t === void 0 && (t = !0);
  var n = (0, we.useMemo)(function() {
    return ae(ae({}, r), { fromSocketIO: !0 });
  }, []), o = (0, bt.useWebSocket)(e, n, t), a = o.sendMessage, c = o.sendJsonMessage, u = o.lastMessage, l = o.readyState, s = o.getWebSocket, f = (0, we.useMemo)(function() {
    return Ot(u);
  }, [u]);
  return {
    sendMessage: a,
    sendJsonMessage: c,
    lastMessage: f,
    lastJsonMessage: f,
    readyState: l,
    getWebSocket: s
  };
};
de.useSocketIO = pt;
var ve = {}, oe = O && O.__assign || function() {
  return oe = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, oe.apply(this, arguments);
}, wt = O && O.__rest || function(e, r) {
  var t = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      r.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (t[n[o]] = e[n[o]]);
  return t;
};
Object.defineProperty(ve, "__esModule", { value: !0 });
ve.useEventSource = void 0;
var Te = Ee, Tt = B, Ne = G, Nt = function(e, r, t) {
  r === void 0 && (r = Ne.DEFAULT_EVENT_SOURCE_OPTIONS);
  var n = r.withCredentials, o = r.events, a = wt(r, ["withCredentials", "events"]);
  t === void 0 && (t = !0);
  var c = oe(oe({}, a), { eventSourceOptions: {
    withCredentials: n
  } }), u = (0, Te.useRef)(Ne.EMPTY_EVENT_HANDLERS);
  o && (u.current = o);
  var l = (0, Tt.useWebSocket)(e, c, t), s = l.lastMessage, f = l.readyState, v = l.getWebSocket;
  return (0, Te.useEffect)(function() {
    s != null && s.type && Object.entries(u.current).forEach(function(b) {
      var M = b[0], C = b[1];
      M === s.type && C(s);
    });
  }, [s]), {
    lastEvent: s,
    readyState: f,
    getEventSource: v
  };
};
ve.useEventSource = Nt;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.resetGlobalState = e.useEventSource = e.ReadyState = e.useSocketIO = e.default = void 0;
  var r = B;
  Object.defineProperty(e, "default", { enumerable: !0, get: function() {
    return r.useWebSocket;
  } });
  var t = de;
  Object.defineProperty(e, "useSocketIO", { enumerable: !0, get: function() {
    return t.useSocketIO;
  } });
  var n = G;
  Object.defineProperty(e, "ReadyState", { enumerable: !0, get: function() {
    return n.ReadyState;
  } });
  var o = ve;
  Object.defineProperty(e, "useEventSource", { enumerable: !0, get: function() {
    return o.useEventSource;
  } });
  var a = V;
  Object.defineProperty(e, "resetGlobalState", { enumerable: !0, get: function() {
    return a.resetGlobalState;
  } });
})(H);
const ee = /* @__PURE__ */ De(H);
globalThis && globalThis.__awaiter;
function Mt(e) {
  const r = Ce(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  return ke(() => {
    r.current = e;
  }, [e]), _e((...t) => r.current(...t), [r]);
}
function Me(e, r, t, n) {
  const o = Ce(r);
  ke(() => {
    o.current = r;
  }, [r]), $(() => {
    var a;
    const c = (a = t == null ? void 0 : t.current) !== null && a !== void 0 ? a : window;
    if (!(c && c.addEventListener))
      return;
    const u = (l) => o.current(l);
    return c.addEventListener(e, u, n), () => {
      c.removeEventListener(e, u, n);
    };
  }, [e, t, n]);
}
globalThis && globalThis.__awaiter;
const ke = typeof window < "u" ? Ue : $;
function Ie(e, r) {
  const t = _e(() => {
    if (typeof window > "u")
      return r;
    try {
      const u = window.localStorage.getItem(e);
      return u ? It(u) : r;
    } catch (u) {
      return console.warn(`Error reading localStorage key \u201C${e}\u201D:`, u), r;
    }
  }, [r, e]), [n, o] = _(t), a = Mt((u) => {
    typeof window > "u" && console.warn(`Tried setting localStorage key \u201C${e}\u201D even though environment is not a client`);
    try {
      const l = u instanceof Function ? u(n) : u;
      window.localStorage.setItem(e, JSON.stringify(l)), o(l), window.dispatchEvent(new Event("local-storage"));
    } catch (l) {
      console.warn(`Error setting localStorage key \u201C${e}\u201D:`, l);
    }
  });
  $(() => {
    o(t());
  }, []);
  const c = _e((u) => {
    (u == null ? void 0 : u.key) && u.key !== e || o(t());
  }, [e, t]);
  return Me("storage", c), Me("local-storage", c), [n, a];
}
function It(e) {
  try {
    return e === "undefined" ? void 0 : JSON.parse(e != null ? e : "");
  } catch {
    console.log("parsing error on", { value: e });
    return;
  }
}
const kt = ({
  host: e = "127.0.0.1",
  port: r = 9002,
  mode: t = "stream",
  needHistory: n = !0,
  historySize: o = 100,
  shouldConnect: a = !0
} = {}) => {
  const [c, u] = _(""), [l, s] = _(0), [f, v] = _(), [b, M] = _({
    width: 0,
    height: 0
  }), C = 0, P = 1, S = 2, [E, I] = _(P), [g, h] = n ? Ie("dataFromWs", []) : _([]), [A, y] = n ? Ie("settings", void 0) : _(void 0), [p, k] = _(
    void 0
  ), U = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/gi, W = Z(
    () => (U.test(e) || e === "localhost" ? "ws://" : "wss://") + e + ":" + r.toString() + "/",
    [e]
  ), { sendJsonMessage: d, lastJsonMessage: T } = ee(
    W,
    {
      onOpen: () => {
        u(""), Ae(), me(), w(), be();
      },
      onError: (m) => {
        console.error(m), u(
          "Server unavailable, please try later or contact us."
        );
      },
      shouldReconnect: () => !0,
      reconnectInterval: 3e3
    },
    a
  );
  $(() => {
    let m = T;
    if (m && m.pre === "paramrx")
      m && y(m);
    else if (m && m.pre === "getbayercoefs")
      m.values && k(m.values);
    else if (m && m.pre === "bayernorm")
      me();
    else if (m && m.pre === "jpegrx" && m.data)
      v(m.data), M({
        width: m.im_width,
        height: m.im_height,
        time: m.time
      });
    else if (m && m.data) {
      let N = m.data.split(","), q = Number(
        N[0].trim().replace(/^[\[,0]+/, "").replace(/\]+$/, "")
      );
      if (q !== l) {
        if (s(q), t === "stream" && E === C)
          return;
        t === "stream" && E === S && I(C);
        const Q = {
          id: q,
          x: parseFloat(parseFloat(N[1].trim()).toFixed(15)),
          y: parseFloat(parseFloat(N[2].trim()).toFixed(15)),
          z: parseFloat(parseFloat(N[3].trim()).toFixed(15)),
          rotX: parseFloat(
            parseFloat(N[4].trim()).toFixed(12)
          ),
          rotY: parseFloat(
            parseFloat(N[5].trim()).toFixed(12)
          ),
          rotZ: parseFloat(
            parseFloat(N[6].trim()).toFixed(12)
          ),
          xString: N[1].trim(),
          yString: N[2].trim(),
          zString: N[3].trim(),
          rotXString: N[4].trim(),
          rotYString: N[5].trim(),
          rotZString: N[6].trim(),
          q: parseInt(N[7].trim()),
          m: N[12].trim()
        };
        L(q, Q), t === "request" && Se();
      }
    }
  }, [T]);
  const L = (m, N) => {
    o && g.length >= o ? g.find((Q, We) => {
      if (Q.id === m)
        return h([N]), !0;
    }) || h([
      ...g.slice(g.length - o + 1),
      N
    ]) : g.find((Q, We) => {
      if (Q.id === m)
        return h([N]), !0;
    }) || h([...g, N]);
  }, w = () => {
    I(P), t === "request" && Se();
  }, i = () => {
    I(C);
  }, j = () => {
    E !== C && I(C), t === "request" ? Se() : I(S);
  }, Re = () => {
    h([]), window.location.reload();
  }, Se = () => {
    d({ command: "strobe" }), d({ command: "datarx" });
  }, Ae = () => {
    d({ command: "paramrx" });
  }, me = () => {
    d({ command: "getbayercoefs" });
  }, Le = () => {
    d({ command: "bayernorm" });
  }, be = () => {
    d({ command: "jpegrx" });
  };
  return {
    errorMessage: c,
    data: g,
    settings: A,
    play: w,
    pause: i,
    step: j,
    reset: Re,
    normalizeHisto: Le,
    bayerParams: p,
    fullImage: f,
    fullImageParams: b,
    getFullImage: be
  };
}, Rt = ({
  host: e = "127.0.0.1",
  port: r = 8095,
  shouldConnect: t = !0
} = {}) => {
  const [n, o] = _(""), [a, c] = _(8), [u, l] = _(!0), [s, f] = _(0), [v, b] = _(65535), [M, C] = _(), P = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/gi, S = Z(
    () => (P.test(e) || e === "localhost" ? "ws://" : "wss://") + e + ":" + r.toString() + "/",
    [e]
  ), {
    sendMessage: E,
    sendJsonMessage: I,
    lastMessage: g,
    lastJsonMessage: h,
    readyState: A
  } = ee(
    S,
    {
      onOpen: () => {
        o(""), p(), k(), U(), y();
      },
      onError: (i) => {
        console.error(i), o(
          "Server unavailable, please try later or contact us."
        );
      },
      shouldReconnect: (i) => !0,
      reconnectInterval: 3e3
    },
    t
  );
  $(() => {
    try {
      JSON.parse(g == null ? void 0 : g.data);
    } catch {
      g != null && g.data && C(g.data);
    }
  }, [g]), $(() => {
    let i = h;
    i && i.type && (i.type === "low-bit" && i.value ? c(i.value) : i.type === "max-value" && i.value ? b(i.value) : i.type === "min-value" && i.value ? f(i.value) : i.type === "gain-mode" && i.value ? i.value === 3 ? l(!1) : l(!0) : i.type === "control" && i.msg === "error" && o(i.description));
  }, [h]);
  const y = () => {
    E("get-raw");
  }, p = () => {
    I({ command: "get-max-value" });
  }, k = () => {
    I({ command: "get-min-value" });
  }, U = () => {
    I({ command: "get-gain-mode" });
  }, W = (i) => {
    A === H.ReadyState.OPEN && (I({
      command: "set-low-bit",
      value: i.currentTarget.value.toString()
    }), c(parseInt(i.currentTarget.value, 10)));
  }, d = (i) => {
    A === H.ReadyState.OPEN && (i ? (w(1), l(!0)) : (w(3), L(0), p(), l(!1)));
  }, T = (i) => {
    A === H.ReadyState.OPEN && !u && (I({
      command: "set-max-value",
      value: i.toString()
    }), b(i));
  }, L = (i) => {
    I({
      command: "set-min-value",
      value: i.toString()
    });
  }, w = (i) => {
    I({
      command: "set-gain-mode",
      value: i.toString()
    });
  };
  return {
    errorMessage: n,
    image: M,
    sendRange: W,
    range: a,
    switchAutoMode: d,
    autoMode: u,
    sendMax: T,
    max: v,
    min: s,
    getImage: y
  };
}, At = ({
  host: e = "127.0.0.1",
  port: r = 0,
  token: t = "",
  historySize: n = 300,
  shouldConnect: o = !0
} = {}) => {
  const [a, c] = _(""), u = 0, l = 1, s = 2, [f, v] = _(l), [b, M] = _([]), [C, P] = _(0), S = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/gi, E = Z(
    () => (S.test(e) || e === "localhost" ? "ws://" : "wss://") + e + (r ? ":" + r.toString() : "") + "/" + (t ? "?token=" + t : ""),
    [e]
  ), { sendJsonMessage: I, lastJsonMessage: g } = ee(
    E,
    {
      onOpen: () => {
        c(""), U(t);
      },
      onError: (d) => {
        console.error(d), c(
          "Server unavailable, please try later or contact us."
        );
      },
      shouldReconnect: () => !0,
      reconnectInterval: 3e3
    },
    o
  );
  $(() => {
    let d = g;
    if (d && d.msg && d.msg === "position" && d.data && d.data.index && d.data.index !== C) {
      if (c(""), P(d.data.index), f === u)
        return;
      const T = h(d.data);
      A(d.data.index, T);
    } else if (d && d.msg && d.msg === "history") {
      if (d.data && d.data.length > 0) {
        const T = d.data.map(
          (L) => h(L)
        );
        M(T), P(d.data[d.data.length - 1].index);
      }
    } else
      d && d.msg && d.msg === "error" && (d.action && d.action === "write" ? c("Currently no write permission") : d.action && d.action === "read" ? c("Currently no read permission") : c(
        "Server unavailable, please try later or contact us."
      ));
  }, [g]);
  const h = (d) => {
    var T;
    return {
      id: d.index,
      x: parseFloat(d.val_px.toFixed(12)),
      y: parseFloat(d.val_py.toFixed(12)),
      z: parseFloat(d.val_pz.toFixed(12)),
      rotX: parseFloat(d.val_rx.toFixed(9)),
      rotY: parseFloat(d.val_ry.toFixed(9)),
      rotZ: parseFloat(d.val_rz.toFixed(9)),
      xString: d.val_px.toString(),
      yString: d.val_py.toString(),
      zString: d.val_pz.toString(),
      rotXString: d.val_rx.toString(),
      rotYString: d.val_ry.toString(),
      rotZString: d.val_rz.toString(),
      q: 0,
      m: d.good.trim(),
      time: (T = d.time) != null ? T : ""
    };
  }, A = (d, T) => {
    n && b.length >= n ? b.find((w, i) => {
      if (w.id === d)
        return !0;
    }) || M([
      ...b.slice(b.length - n + 1),
      T
    ]) : b.find((w, i) => {
      if (w.id === d)
        return !0;
    }) || M(
      (w) => w.length > 0 && !w.find((i) => i.id === T.id) ? [...w, T] : [...w]
    );
  }, y = () => {
    v(l);
  }, p = () => {
    v(u);
  }, k = () => {
    f !== u && v(u), v(s);
  }, U = (d) => {
    I({ mode: "stream", token: d });
  };
  return {
    errorMessage: a,
    data: b,
    play: y,
    pause: p,
    step: k,
    reset: () => {
      M([]), window.location.reload();
    }
  };
}, Lt = ({
  host: e = "127.0.0.1",
  port: r = 0,
  token: t = "",
  shouldConnect: n = !0
} = {}) => {
  const [o, a] = _(""), [c, u] = _(8), [l, s] = _(!0), [f, v] = _(0), [b, M] = _(65535), [C, P] = _(), S = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/gi, E = Z(
    () => (S.test(e) || e === "localhost" ? "ws://" : "wss://") + e + (r ? ":" + r.toString() : "") + "/" + (t ? "?token=" + t : ""),
    [e]
  ), {
    sendMessage: I,
    sendJsonMessage: g,
    lastMessage: h,
    lastJsonMessage: A,
    readyState: y
  } = ee(
    E,
    {
      onOpen: () => {
        a(""), p(t);
      },
      onError: (i) => {
        console.error(i), a(
          "Server unavailable, please try later or contact us."
        );
      },
      shouldReconnect: (i) => !0,
      reconnectInterval: 3e3
    },
    n
  );
  $(() => {
    try {
      JSON.parse(h == null ? void 0 : h.data);
    } catch {
      h != null && h.data && P(h.data);
    }
  }, [h]), $(() => {
    let i = A, j;
    return i && i.type && (i.type === "low-bit" && i.value ? u(i.value) : i.type === "max-value" && i.value ? M(i.value) : i.type === "min-value" && i.value ? v(i.value) : i.type === "gain-mode" && i.value ? i.value === 3 ? s(!1) : s(!0) : i.type === "control" && i.msg === "error" ? (a(i.description), i.action && i.action === "write" ? a("Currently no write permission") : i.action && i.action === "read" ? (j = setTimeout(() => {
      k();
    }, 5e3), a("Currently no read permission")) : a(
      "Server unavailable, please try later or contact us."
    )) : i.type === "ack" && k()), () => {
      j && clearTimeout(j);
    };
  }, [A]);
  const p = (i) => {
    g({ mode: "read", token: i });
  }, k = () => {
    I("get-raw");
  }, U = () => {
    g({ command: "get-max-value" });
  }, W = (i) => {
    y === H.ReadyState.OPEN && (g({
      command: "set-low-bit",
      value: i.currentTarget.value.toString()
    }), u(parseInt(i.currentTarget.value, 10)));
  }, d = (i) => {
    y === H.ReadyState.OPEN && (i ? (w(1), s(!0)) : (w(3), L(0), U(), s(!1)));
  }, T = (i) => {
    y === H.ReadyState.OPEN && !l && (g({
      command: "set-max-value",
      value: i.toString()
    }), M(i));
  }, L = (i) => {
    g({
      command: "set-min-value",
      value: i.toString()
    });
  }, w = (i) => {
    g({
      command: "set-gain-mode",
      value: i.toString()
    });
  };
  return {
    errorMessage: o,
    image: C,
    sendRange: W,
    range: c,
    switchAutoMode: d,
    autoMode: l,
    sendMax: T,
    max: b,
    min: f,
    getImage: k
  };
}, Wt = ({
  host: e = "127.0.0.1",
  port: r = 0,
  token: t = "",
  shouldConnect: n = !0
} = {}) => {
  const [o, a] = _(""), [c, u] = _([]), l = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/gi, s = Z(
    () => (l.test(e) || e === "localhost" ? "ws://" : "wss://") + e + (r ? ":" + r.toString() : "") + "/" + (t ? "?token=" + t : ""),
    [e]
  ), { sendJsonMessage: f, lastJsonMessage: v, readyState: b } = ee(
    s,
    {
      onOpen: () => {
        a(""), C(t);
      },
      onError: (S) => {
        console.error(S), a(
          "Server unavailable, please try later or contact us."
        );
      },
      shouldReconnect: () => !0,
      reconnectInterval: 3e3
    },
    n
  );
  $(() => {
    let S = v;
    if (S && S.positions) {
      if (S.channels)
        for (const E in S.channels)
          S.channels[E] = M(
            S.channels[E]
          ).toFixed(4);
      if (S.positions)
        for (const E in S.positions)
          S.positions[E] = M(
            S.positions[E]
          ).toFixed(4);
      u(S);
    } else
      S && S.msg && S.msg === "error" && (S.action && S.action === "write" ? a("Currently no write permission") : S.action && S.action === "read" ? a("Currently no read permission") : a(
        "Server unavailable, please try later or contact us."
      ));
  }, [v]);
  const M = (S) => {
    let E = Number(S);
    return E > 1 ? 1 : E < -1 ? -1 : E;
  }, C = (S) => {
    f({ mode: "stream", token: S });
  };
  return {
    errorMessage: o,
    data: c,
    send: (S) => {
      let E = {
        token: t,
        ...S
      };
      b === WebSocket.OPEN && f(E);
    }
  };
};
export {
  Lt as useMidlayerWebsocketImage,
  Wt as useMidlayerWebsocketPositionControl,
  At as useMidlayerWebsocketPositionData,
  Rt as useWebsocketImage,
  kt as useWebsocketPositionData
};
